import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  Grid,
  Hidden,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import * as styles from "../styles.scss";
import { SvgIcon } from "../../../../../../components";
import { tl } from "../../../../../../utils";

import { IFile } from "../../../types";

interface IProps {
  data: IFile;
  onPreview?: any;
  canDelete?: boolean;
}

export const FilecardImage = observer((props: IProps) => {
  const { fsStore } = React.useContext(MobXProviderContext);
  const theme = useTheme();

  return (
    <Grid item xs={6} sm={4} md={3}>
      <Card className={styles.cardsFile}>
        <CardMedia
          image={
            props.data.category === "image"
              ? props.data.icon_card || props.data.srcUrl
              : props.data.icon_card || null
          }
          className={styles.cardsPoster}
        >
          {props.data.category === "image" ? null : (
            <Box className={styles.cardsFiletypeIcon}>
              <SvgIcon type={`fs-card-${props.data.category}`} />
            </Box>
          )}

          {fsStore.canDownload || fsStore.canEdit ? (
            <Box m={0.5} className={styles.cardsControls}>
              <Grid container>
                {fsStore.canDownload ? (
                  <a
                    href={props.data.downloadUrl}
                    target="_blank"
                    title={tl("Скачать")}
                    className={styles.cardsControlsListItem}
                  >
                    <SvgIcon type="fs-card-download" />
                  </a>
                ) : null}

                {fsStore.canEdit ? (
                  <a
                    href={`/panel/files/edit?course_id=${
                      fsStore.course_id ? fsStore.course_id : props.data.course
                    }&id=${props.data.id}&category=index`}
                    title={tl("Настройки файла")}
                    target="_blank"
                    className={styles.cardsControlsListItem}
                  >
                    <SvgIcon type="fs-card-settings" />
                  </a>
                ) : null}
              </Grid>
            </Box>
          ) : null}

          {fsStore.isFilesCheckAvailable || props.canDelete ? (
            <>
              <Box className={styles.cardsCheck}>
                <Checkbox
                  checked={fsStore.isFileChecked(props.data)}
                  onChange={() => fsStore.onFileCheck(props.data)}
                  color="primary"
                />
              </Box>
              {fsStore.onAttach ? (
                <Hidden only="xs">
                  {fsStore.getCheckedFilesCount ? (
                    <Box
                      m={0.5}
                      className={`${styles.cardsControls} ${styles.cardsControlsPreview}`}
                      onClick={() => {
                        props.onPreview(props.data.id, props.data.category);
                      }}
                    >
                      <SvgIcon type="fs-card-preview_white" />
                    </Box>
                  ) : (
                    <Box m={0.5} className={styles.cardsAttach}>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          fsStore.onAttachAll([props.data]);
                        }}
                      >
                        {tl("Прикрепить")}
                      </Button>
                    </Box>
                  )}
                </Hidden>
              ) : null}
            </>
          ) : null}
        </CardMedia>
        <CardContent className={styles.cardsInfo}>
          <Box
            m={-1}
            color={theme.palette.primary.main}
            className={styles.cardsFilename}
            title={`${props.data.name}${props.data.extension}`}
          >
            {props.data.name}
            {props.data.extension}
          </Box>
        </CardContent>

        <Box
          title={`${props.data.name}${props.data.extension}`}
          onClick={
            fsStore.getCheckedFilesCount
              ? () => fsStore.onFileCheck(props.data)
              : () => props.onPreview(props.data.id, props.data.category)
          }
          className={styles.cardsMask}
        />
      </Card>
    </Grid>
  );
});
